import * as React from "react";

import { cn } from "@/lib/utils";

/**
 * Input — MOMENTUM form primitive.
 *
 * Sized to match the new Button system (h-9, PR #179). Inert inputs
 * pre-focus felt dead; this adds a subtle hover border bump so the
 * trainer can see the input is alive before clicking.
 *
 * Token-driven border (border-border, not border-input) so themes
 * stay consistent with cards and buttons.
 */
const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-9 w-full rounded-md border border-border bg-background px-3 py-1.5 text-sm tracking-tight",
          "ring-offset-background transition-[border-color,box-shadow] duration-150",
          "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
          "placeholder:text-muted-foreground/70",
          "hover:border-border/80",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:border-ring/40",
          "disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:border-border",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
